import React, { useContext } from "react";
import PropTypes from "prop-types";
import UserPrefsContext from "../../../context/UserPrefs/UserPrefsContext";

import Select from "../../shared/InputElements/Select";
import { useIntl } from "react-intl";

const SelectInstallationCosts = ({ id = "select-installation-costs", ...rest }) => {
     const intl = useIntl();
     const userPrefs = useContext(UserPrefsContext);
     let installCost = userPrefs.get("installCost");

     const label = intl.formatMessage
          ? intl.formatMessage({ id: "estimateInstallationCosts", defaultMessage: "Estimated Installation Costs" })
          : "Estimated Installation Costs";

     const optionNames = ["None: $0", "Low: $500", "Avg: $1,000", "High: $2,000"];
     const optionValues = ["0", "500", "1000", "2000"];

     return (
          <Select
               id={id}
               value={installCost}
               label={label}
               optionNames={optionNames}
               optionValues={optionValues}
               handler={(e) => {
                    userPrefs.set({ installCost: e.target.value });
               }}
               {...rest}
          />
     );
};

export default SelectInstallationCosts;

SelectInstallationCosts.propTypes = {
     id: PropTypes.string,
     label: PropTypes.string,
};
